/**
 * Scroll a pint portfolio beer card into view and move keyboard focus to it.
 *
 * @returns true when the card element was found and focused
 */
export function focusPortfolioBeerCard(beerId: string): boolean {
  if (typeof beerId !== 'string' || beerId.length === 0) {
    return false;
  }

  const card = document.querySelector(`[data-beer-id="${window.CSS.escape(beerId)}"]`);
  if (!card || !('focus' in card) || typeof card.focus !== 'function') {
    return false;
  }

  card.scrollIntoView({ block: 'nearest', behavior: 'instant' });
  card.focus({ preventScroll: true });
  return true;
}
